/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.24.0
 */

import { Button, MenuItem } from '@nexign/scc-ui-kit';
import styled, { css } from 'styled-components';

const HoverItemStyle = css`
    opacity: 0.7;
    &:hover {
        opacity: 1;
    }
    transition: opacity 200ms;
`;

export const UserNotificationsContainerStyled = styled.div.attrs({
    className: 'user-notifications',
})`
    width: fit-content;
`;

export const StyledNotificationsHeaderMenuContainer = styled.div`
    display: flex;
    & .Menu_Wrapper_Icon {
        svg path {
            fill: ${(props) => props.theme.palette.currentColors.FullBlack};
        }
    }
    & .Menu_Wrapper {
        ${HoverItemStyle}
    }
`;

export const StyledNotificationsHeaderMenuItem = styled(MenuItem)`
    && {
        display: flex;
        justify-content: flex-start;
        & > :first-child {
            margin-right: 8px;
        }
    }
`;

export const StyledNotificationsButtonLink = styled(Button)`
    padding: 0;
    ${HoverItemStyle};
`;

export const StyledNotificationsEmptyListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 0;
`;
